import Vue from "vue"
import App from "@/App.vue"

import "@/plugins/compositionApi"
import vuetify from "@/plugins/vuetify"
import i18n from "@/plugins/i18n"

// ログインurl保持(ログアウトで利用)#25858
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.$cookies.set(process.env.VUE_APP_LOGOUT_REDIRECT_COOKIE_NAME, location.href, '1d', '/')

Vue.config.productionTip = false
Vue.config.devtools = true

// google tag manager#26877,#30865
import VueGtm from "@gtm-support/vue2-gtm"
Vue.use(VueGtm, {
  id: [process.env.VUE_APP_GTM_CONTAINER_ID, process.env.VUE_APP_GTM_CONTAINER_ID2],
  enabled: true,
})

new Vue({
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount("#app")
